import React, { useMemo } from 'react';
import styles from './Button.module.scss';
import useTranslation from '../../../../../Hooks/useTranslation';
import FirstUpper from '../../FirstUpper';
import { Theme } from '../../../Enums/Theme.enum';
import Loading from '../../Loading';

interface Props {
	onClick?: () => void;
	href?: string;
	title: string;
	icon?: string;
	subtitle?: string;
	showArrow?: boolean;
	className?: string;
	theme?: Theme;
	badge?: string;
	disabled?: boolean;
}

const Button: React.FC<Props> = ({
	onClick,
	href,
	title,
	icon,
	subtitle,
	showArrow = true,
	className,
	theme,
	badge,
	disabled = false,
}) => {
	const { t } = useTranslation();

	const arrowIcon: string = useMemo(() => {
		switch (theme) {
			case Theme.PURPLE:
			case Theme.GREEN:
				return '/dist/patientV3/icons/arrow-right-white-small.svg';
			default:
				return '/dist/patientV3/icons/arrow-right-purple-small.svg';
		}
	}, [theme]);

	const handleClick = () => {
		if (!disabled) onClick?.();
	};

	const classNameValue = [
		styles.button,
		className,
		theme && styles[theme],
		disabled && styles.disabled,
		onClick || href ? styles.clickable : '',
	].join(' ');

	const content = (
		<>
			{badge && <div className={styles.badge}>{badge}</div>}
			{icon && <img src={icon} className={styles.icon} />}
			<div className={styles.content}>
				<div className={styles.title}>
					<FirstUpper>{t(title)}</FirstUpper>
				</div>
				{subtitle && (
					<div className={styles.subtitle}>
						<FirstUpper>{t(subtitle)}</FirstUpper>
					</div>
				)}
			</div>
			{showArrow && (
				<div className={styles.arrow}>
					<img src={arrowIcon} alt='arrow icon' />
				</div>
			)}
		</>
	);

	if (href) {
		return (
			<a
				className={classNameValue}
				href={href}
				target='_blank'
				rel='noopener noreferrer'
			>
				{content}
			</a>
		);
	}

	return (
		<div className={classNameValue} onClick={handleClick}>
			{content}
		</div>
	);
};

export default Button;
